import { Component, OnInit, ElementRef, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { StepperDetails } from 'src/app/modules/user-profile/models/stepper-details';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';


@Component({
    selector: 'app-contact-verification-stepper',
    templateUrl: './contact-verification-stepper.component.html',
    styleUrls: ['./contact-verification-stepper.component.css'],
    imports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContactVerificationStepperComponent implements OnInit {
  cService = inject(ContactVerificationService);
  private elementRef = inject(ElementRef);
  private cDataService = inject(ContactDataService);

 
  ngOnInit(): void {
  }
  stepperClick($event) {
    if ($event.detail.label) {
      this.cService.setStep($event.detail.label);
      let stepindex = this.cService.stepperList.items.findIndex(x => x.label == $event.detail.label);
      this.cService.stepCount = stepindex + 1;
    }
  }
}
